/**
 * The DOM event names a tokenizer reads as keywords: English's event words,
 * and every name a language's event word normalizes to. A leaf module, so a
 * reader can ask without importing a tokenizer.
 */
export const EVENT_NAMES: ReadonlySet<string> = new Set([
  'click',
  'dblclick',
  'mousedown',
  'mouseup',
  'mouseover',
  'mouseout',
  'mouseenter',
  'mouseleave',
  'mousemove',
  'keydown',
  'keyup',
  'keypress',
  'input',
  'change',
  'submit',
  'reset',
  'load',
  'unload',
  'scroll',
  'resize',
  'focus',
  'blur',
  'contextmenu',
  'dragstart',
  'drag',
  'dragend',
  'dragenter',
  'dragleave',
  'dragover',
  'drop',
  'touchstart',
  'touchmove',
  'touchend',
  'touchcancel',
]);
